import { Stack, Typography } from '@mui/joy';
import { memo } from 'react';
import { FcExpired } from 'react-icons/fc';

const DeletedSession = memo(() => {
  return (
    <Stack justifyContent="center" alignItems="center" flexGrow={1} rowGap={5}>
      <FcExpired size={140} />
      <Stack sx={{ textAlign: 'center', px: '16px' }} spacing={'8px'}>
        <Typography level="body-md" fontWeight={600}>
          병원에서 삭제한 검사 입니다.
        </Typography>
        <Typography level="body-md" fontWeight={600}>
          병원에 문의해주세요.
        </Typography>
      </Stack>
    </Stack>
  );
});

DeletedSession.displayName = 'DeletedSession';

export { DeletedSession };

